import React, { FC } from "react";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { InnerBox } from "@/components/elements/InnerBox";
import { Grid } from "@mui/material";
import { CompanyInfoItem } from "@/features/company/components/company-detail/CompanyInfoItem";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";

type TCompanyDetailProps = {
  defaultValues?: Partial<TCompanyForm>;
};

export const CompanyAdditionalDetailInfo: FC<TCompanyDetailProps> = ({ defaultValues }) => {
  return (
    <InnerBox title={<CompanyFormTitle text="その他の情報" />} showDivider={false}>
      <Grid
        container
        sx={{
          marginTop: "24px",
        }}
      >
        <Grid item xs={12}>
          <CompanyInfoItem label="事業内容・企業特性" value={defaultValues?.companyDescription} type="textArea" />
          <CompanyInfoItem label="メモ" value={defaultValues?.memo} isShowDivider={false} type="textArea" />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
